<section class="content" style="margin: 40px !important;">
    <div class="container-fluid">
        <div class="page-title">
            <span>
                <i class="fas fa-user"></i>
                <strong class="mx-2">{{'Profile' | translate}}</strong>
            </span>
        </div>

        <div class="row clearfix">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card">
                    <form #userForm="ngForm" class="form">
                        <div class="body">
                            <div class="row">
                                <div class="col-lg-8 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.employee_name" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-text-box placeholder="{{'user.employee_name' | translate}}"
                                                    [(ngModel)]="user.name" id="txtUserName" name="userName" ngModel
                                                    required #txtUserName="ngModel"></dx-text-box>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.user_name" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-text-box placeholder="{{'user.user_name' | translate}}"
                                                    [(ngModel)]="user.username" id="txtUserUsername" name="userUsername"
                                                    ngModel #txtUserUsername="ngModel" [disabled]="true">
                                                </dx-text-box>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.phone" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-text-box placeholder="{{'user.phone' | translate}}"
                                                    id="txtUserMobile" name="UserMobile" [(ngModel)]="user.mobile"
                                                    ngModel required #txtUserMobile="ngModel"></dx-text-box>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.city" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-text-box placeholder="{{'user.city' | translate}}" id="txtUserCity"
                                                    name="userCity" [(ngModel)]="user.city" ngModel required
                                                    #txtUserCity="ngModel"></dx-text-box>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.country" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-select-box [dataSource]="countries" displayExpr="nameAr"
                                                    valueExpr="id" placeholder="{{'user.country' | translate}}"
                                                    name="country" ngModel required [(ngModel)]="user.countryId"
                                                    id="txtUserCountry" #txtUserCountry="ngModel"
                                                    [searchEnabled]="true">
                                                </dx-select-box>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6 col-md-12  mb-3">
                                            <div class="dx-field-label mb-3">{{"user.email" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-text-box placeholder="{{'user.email' | translate}}"
                                                    id="txtUserEmail" name="userEmail" [(ngModel)]="user.email" ngModel
                                                    required #txtUserEmail="ngModel"></dx-text-box>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12  mb-3 ">
                                            <div class="dx-field-label mb-3">{{"user.language" | translate}}</div>
                                            <div class="dx-field-value">
                                                <dx-select-box [dataSource]="languages" displayExpr="nameAr"
                                                    valueExpr="id" placeholder="{{'user.language' | translate}}"
                                                    name="language" ngModel [(ngModel)]="user.languageId">
                                                </dx-select-box>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-12 m-3">{{"user.signingMethod" | translate}}</div>
                                        <div class="col-lg-6 col-sm-12" style="margin-bottom: 1rem;">
                                            <button (click)="showUploadSection()"
                                                class="btn save_btn sign_way"><i class="fas fa-upload" style="margin: 0 5px;"></i> {{"user.uploadSignature" | translate}}</button>
                                        </div>

                                        <div class="col-lg-6 col-sm-12" style="margin-bottom: 1rem;">
                                            <button (click)="showWriteDection()"
                                                class="btn save_btn sign_way"><i class="fas fa-marker" style="margin: 0 5px;"></i> {{"user.writeSignature" | translate}}</button>
                                        </div>

                                        <div class="col-lg-12">
                                            <img style="width: -webkit-fill-available;" id="sign_img" class="sign_img"
                                                src='{{ "data:image/png;base64," + this.user.photoBase64 }}' />
                                        </div>
                                    </div>

                                    <!-- Upload Signature Section -->
                                    <div [hidden]="isShowUpload" class="row">
                                        <div class="col-12 mb-3 ">{{"user.uploadSign" | translate}}</div>
                                        <div class="col-lg-6  col-sm-12 d-flex align-items-center">
                                            <div class="uploadSign">
                                                <input dir="ltr" type="file" accept="image/x-png,image/gif,image/jpeg"
                                                    (change)="userSignImage_onChange($event)" id="txtUserSignature"
                                                    name="userSignature" ngModel #txtUserSignature="ngModel"
                                                    [(ngModel)]="user.photoBase64">
                                                <label for="txtUserSignature"
                                                    class="input_file_label d-flex align-items-center">
                                                    <i class="fas fa-cloud-upload-alt" style="margin: 0 5px;"></i> {{"user.uploadTheSignature" | translate}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-sm-12">
                                            <button class="btn close_btn remove_signature" [disabled]="!uploadSignature"
                                                (click)="removeSignature()">
                                                <i class="fas fa-trash" style="margin: 0 5px;"></i> {{"user.removeSignature" | translate}}
                                            </button>
                                        </div>
                                        <div class="col-12  my-3">
                                            <img id="sign_img" class="sign_img" src='{{ signatureImg }}' />
                                        </div>
                                    </div>

                                    <!-- Write Signature Section -->
                                    <div [hidden]="isShowWrite" class="row">
                                        <div class="col-12">{{"user.writeTheSignature" | translate}}</div>


                                        <div class="col-12 my-3 ">
                                            <div class="digital-signature">
                                                <div class="digital-signature-body">
                                                    <canvas #signatureCanvas
                                                        style="width: 100%; height: 100%;"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn save_btn"
                                                (click)="saveJustSignature()">{{"user.saveSignature" |
                                                translate}}</button>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn close_btn"
                                                (click)="clearSignature()">{{"user.clearSignature" |
                                                translate}}</button>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn close_btn"
                                                (click)="cancelSavingSignatrue()">{{"user.undoSignature" |
                                                translate}}</button>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn save_btn" (click)="savePNG()">{{"user.savePNG" |
                                                translate}}</button>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn save_btn" (click)="saveJPG()">{{"user.saveJPG" |
                                                translate}}</button>
                                        </div>
                                        <div class="col-lg-4 col-sm-6 d-flex align-items-center my-3">
                                            <button class="btn pad-btn save_btn" (click)="saveSVG()">{{"user.saveSVG" |
                                                translate}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="example-button-row">
                                <button mat-raised-button type="button" form="frmCompany" class="btn save_btn"
                                    (click)="saveData()" [disabled]="!userForm.valid">
                                    <i class="fas fa-save"></i> {{'save' | translate}}</button>
                                <!-- <button mat-raised-button type="button" class="btn close_btn"
                                    routerLink="/page/users">{{'back' | translate}}</button> -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>